import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CartService} from "../../../services/cart.service";
import {Cart} from "../../../models/CartModels/cart";
import {CartItem} from "../../../models/CartModels/cartItem";
import {RegistryService} from "../../../services/registry.service";
import {OrderSummary} from "../../../models/CartModels/Checkout/OrderSummary";
import {MapComponent} from "../../../../admin/components/map/map.component";
import {MatDialog} from "@angular/material/dialog";
import {OrderProgressDialogComponent} from "./order-progress-dialog/order-progress-dialog.component";

@Component({
    selector: 'app-cart-summary',
    templateUrl: './cart-summary.component.html',
    styleUrls: ['./cart-summary.component.css']
})
export class CartSummaryComponent implements OnInit, OnDestroy {
    @ViewChild('stickyCard') cardElement: ElementRef;
    sticky: boolean = false;
    elementPosition: any;

    cart: Cart;
    sum = 0;
    isLoading = false;
    summary: OrderSummary;
    orderReady = false;

    cartReadyEvent;
    orderReadyEvent;
    cartUpdatedEvent;
    currencyChangedEvent;

    current_currency;
    rate;
    constructor(public cartService: CartService,
                private registry: RegistryService,
                private dialog: MatDialog

    ) {

        this.current_currency = registry.current_currency;
        this.currencyChangedEvent = this.registry.CurrencyChangedEvent$.subscribe(currency => {

            this.current_currency = currency;
            this.rate = this.registry.getExchangeRate();
            //this.recalcPrice();

        });

        this.cartUpdatedEvent = cartService.CartChangedEvent$.subscribe(cart => {

            this.cart = cart;



            let subTotal = 0;

            for (let i = 0; i < this.cart.items.length; i++) {
                let newPrice = Math.round(((this.cart.items[i].price * this.cart.items[i].qty) + Number.EPSILON) * 100) / 100;
                subTotal += newPrice;

            }

            if(subTotal < 5) {
            this.reset();
            }

            this.cartService.getCartItems(this.cart).subscribe(items => {
                this.sum = this.getCartSum(items);
            });


        });

        this.orderReadyEvent = cartService.OrderReadyEvent$.subscribe(result => {
            this.orderReady = result;
        });

        this.cartReadyEvent = cartService.CartReadyEvent$.subscribe(result => {

            this.isLoading = true;
            this.cartService.getOrderSummary(this.cartService.selectedShippingAddress,
                this.cartService.selectedShippingMethod).subscribe(result => {

                this.isLoading = false;

                this.summary = result;
                this.cartService.EmitCartSummaryReady(result);
            });


        });


    }

    ngOnInit(): void {
        this.rate = this.registry.getExchangeRate();

        console.log(this.rate);
        this.cart = this.registry.cart;
        this.sum = this.getCartSum(this.cart.items);
        this.cartService.checkOrderReady();

    }

    getCartSum(items: CartItem[]) {

        let sum = 0;
        for (let i = 0; i < items.length; i++) {
            sum += (items[i].qty * items[i].price);
        }

        return Math.round((sum + Number.EPSILON) * 100) / 100;

    }

    setCheckStep(step) {

        this.registry.checkout_step = step;

    }

    ngAfterViewInit() {
        this.elementPosition = this.cardElement.nativeElement.offsetTop + 100;
    }


    @HostListener('window:scroll', ['$event'])
    handleScroll() {
        const windowScroll = window.pageYOffset;
        if (windowScroll >= this.elementPosition && window.innerWidth > 700) {
            this.sticky = true;
        } else {
            this.sticky = false;
        }
    }

    ngOnDestroy(): void {

        this.cartReadyEvent.unsubscribe();
        this.orderReadyEvent.unsubscribe();
        this.cartUpdatedEvent.unsubscribe();
        this.currencyChangedEvent.unsubscribe();
    }

    reset() {

        this.summary = null;

    }

    placeOrder() {


        const dialogRef = this.dialog.open(OrderProgressDialogComponent, {
            width: '650px',
            data: {parent: this}

        });

        //do some quick checks ..
        // if (this.cartService.isCheckOrderReady()) {
        //     this.cartService.placeOrder(this.cartService.selectedShippingAddress, this.cartService.selectedPaymentMethod).subscribe(result => {
        //
        //         //order places successfully.
        //         this.cartService.lastOrderId = result;
        //         //do post process operation
        //         this.cartService.resetOrderSelections();
        //         this.summary = null;
        //         this.cartService.createCustomerCart().subscribe(result => {
        //             this.registry.setupCustomer().subscribe(result => {
        //
        //
        //             })
        //         })
        //
        //
        //     });
        //
        // } else {
        //     //add a notification.
        // }


    }


}
